import { Box } from '@mui/material';
import { FC, useMemo } from 'react';
import { CloseButton, DialogSubTitle, DialogToolbar } from '../../../../shared/dialog/dialog.styles';
import { withApptRequestIvStatusDialogProvider } from '../../hooks/use-appt-request-iv-status-dialog/hoc';
import { useApptRequestIvStatusDialog } from '../../hooks/use-appt-request-iv-status-dialog/hook';
import { IvInfo } from '../../shared/iv-info/iv-info';
import { ApptRequestIvStatusDialog } from '../appt-request-iv-status-dialog';
import { ManuallyVerifiedButton } from '../shared/manually-verified-button';
import { SelfPayButton } from '../shared/self-pay-button';

const PatientDataMissingDialog: FC = () => {
  const { opened, onClose, isLoading, appointmentRequest } = useApptRequestIvStatusDialog();

  const subscriberFullName = useMemo(() => {
    const first = appointmentRequest?.insuranceInfo?.subscriberFirstName;
    const last = appointmentRequest?.insuranceInfo?.subscriberLastName;
    if (first && last) return `${first} ${last}`;
    return first || last || null;
  }, [appointmentRequest]);

  return (
    <ApptRequestIvStatusDialog
      opened={opened}
      title={'Patient Data Missing'}
      subtitle={<Box sx={{ fontWeight: 500 }}>{subscriberFullName}</Box>}
    >
      <DialogSubTitle sx={{ margin: '5px 0 20px 0', display: 'block' }}>
        The insurance verification process encountered the following issues:
      </DialogSubTitle>

      <IvInfo undefinedAsBold={true} sx={{ marginBottom: '20px' }} />

      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading} />
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </ApptRequestIvStatusDialog>
  );
};

export default withApptRequestIvStatusDialogProvider(PatientDataMissingDialog);
